<script>
import options from './StafetDonationFlow.options'
export default options
</script>

<template>
  <article class="kb-stafet-donation-flow">
    <StafetHeader
      :steps="headerSteps"
      :title="labels.title"
      :description="labels.description"
    />

    <div class="kb-stafet-donation-flow__step">
      <component
        :is="currentStepName"
        :labels="labels"
        :nextStepCallback="nextStepCallback"
        :previousStepCallback="previousStepCallback"
        :displayInputError="displayInputError"
        :submitCallback="submitCallback"
        :stafetId="stafetId"
        :donationMinimumAmount="minimumDonationAmount"
        :holdList="holdList"
        :userData="userData"
        :isSubmitting="isSubmitting"
      />
    </div>
  </article>
</template>
